import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Slider,
  TextField,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { ContainedButtonStyles } from "../../styles/GlobalStyles";
import { CloseIcon } from "../../icons";

export default function TrainHistoryFilterModal({
  open,
  onClose,
  filterOption,
  setFilterOption,
}: {
  open: boolean;
  onClose: () => void;
  filterOption: HistoryFilterOption;
  setFilterOption: (filterOption: HistoryFilterOption) => void;
}) {
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [status, setStatus] = useState<string>("All");
  const [accuracy, setAccuracy] = useState<number>(80);

  useEffect(() => {
    console.log(filterOption);
    setStartDate(filterOption?.startDate || "");
    setEndDate(filterOption?.endDate || "");
    setStatus(filterOption?.status || "All");
    setAccuracy(filterOption?.accuracy || 80);
  }, []);

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = new Date(e.target.value);
    // 선택된 날짜의 자정으로 설정
    selectedDate.setHours(23, 59, 59, 999);
    setEndDate(selectedDate.toISOString().split("T")[0]); // ISO 형식으로 저장
  };

  const handleApply = () => {
    console.log("s,e,s,a", startDate, endDate, status, accuracy);
    console.log([startDate, endDate, status, accuracy]);
    setFilterOption({ startDate, endDate, status, accuracy });
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setAccuracy(80);
    setStatus("All");
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          width: "500px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            mb: 2,
          }}
        >
          <Typography variant="h6">필터 설정</Typography>
          <IconButton>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            날짜 범위
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <TextField
              label="시작일"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <Typography>-</Typography>
            <TextField
              label="종료일"
              type="date"
              value={endDate}
              onChange={handleEndDateChange}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            정확도
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <TextField
              value={accuracy}
              onChange={(e) => {
                const num = Number(e.target.value);
                setAccuracy(isNaN(num) ? 0 : num);
              }}
              sx={{ width: "100px" }}
              InputLabelProps={{ shrink: true }}
            />
            <Slider
              value={accuracy}
              onChange={(_, value) => setAccuracy(value as number)}
              min={0}
              max={100}
              sx={{ flex: 1 }}
            />
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            상태
          </Typography>
          <FormControl fullWidth>
            <Select value={status} onChange={(e) => setStatus(e.target.value)}>
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Finished">Finished</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Failed">Failed</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}
        >
          <Button onClick={handleReset} variant="outlined">
            초기화
          </Button>
          <Button onClick={onClose} variant="outlined">
            닫기
          </Button>
          <Button
            variant="contained"
            onClick={handleApply}
            sx={{ ...ContainedButtonStyles }}
          >
            적용
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
